import React, {useCallback, useEffect, useState} from 'react';
import {Handle, Position} from "react-flow-renderer";
import RightClickMenu from "./Components/RightClickMenu";
import StringComponent from "./Components/StringComponent";


const style = {
    outline: "2px solid orange",

}


const ExecuteFunction = ({data, id}) => {

    const theme = (theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: 'hotpink',
            primary: 'black',
        },
    })

    // const [selectedOption, setSelectedOption] = useState({type:""});
    const [stl, setStl] = useState({})
    const [active, setActive] = useState(false)
    const [menu, showMenu] = useState(false)

    const [functions, setFunctions] = useState([])


    const onDoubleClick = useCallback((event) => {
        setActive(true)
        setStl(style)
    }, [active])

    // const [optionsVariables, setOptionsVariables] = useState([])
    // const [textType, setTextType] = useState("text")

    const DisableActive = useCallback((event) => {
        setStl({})
        setActive(false)

        showMenu(false)
    }, [active])

    useEffect(() => {
        data.ActivFun = DisableActive
        data.active = onDoubleClick

        if(!data.commands[0]){
            addFun()
        } else
        setFunctions(data.commands)

    }, [])

    const addFun =  ()=>{
        let arr = [] = functions
        arr.push("")
        data.commands = arr
        setFunctions(arr)
    }




    const removeFun = () => {


        let arr = [] = functions
        arr.pop()
        data.commands = arr
        setFunctions(arr)

    }


    return (

        <div
            style={{...stl, width:"200px"}}
            className="If-node"
        >
            <Handle type="target" className="MainIne" position={Position.Left} style={{top: "20px"}} id="in"/>
            <Handle type="source" className="MainOute" position={Position.Right} style={{top: "20px"}} id="out"/>

            <label>Execute Commands:</label>

            {functions.map((value, index) => <StringComponent index={index} key={index} data={data} id={id}/>)}

            {/*<input style={{background:'transparent', border:"0", outline:"0", color:"white", marginTop:"5px",*/}
            {/*fontStyle:"italic"*/}
            {/*}}*/}
            {/*onChange={e=>data.functionName = e.target.value}*/}
            {/*       defaultValue={data.functionName}*/}
            {/*/>*/}


            {active && <button onClick={addFun} className="PlusButton">+</button>}
            {active && <button onClick={removeFun} className="PlusButton2">-</button>}

            {!active && <div
                onContextMenu={
                    event => {
                        event.preventDefault()
                        showMenu(!menu)
                    }
                }
                className="Shild"></div>}
            {menu && <RightClickMenu data={data} id={id}/>}


        </div>
    );
};

export default ExecuteFunction